module.exports = require('./Switch');